import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "drama-container"
};
const _hoisted_2 = {
  key: 0,
  class: "empty-data-container"
};
const _hoisted_3 = {
  key: 1,
  class: "drama-list"
};
const _hoisted_4 = {
  key: 2,
  class: "pagination-container"
};
import { computed, onMounted, ref } from 'vue';
import { ElIcon, ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import store from '@/store';
import router from '@/router';
import { request } from '@/manager/net_manager';
import { inApostleType } from "@/tools/utils";
import { pageStyle } from "@/theme/sliderStyle";
import DramaHeader from '@/components/Drama/DramaHeader.vue';
import DramaListCard from '@/components/Drama/DramaListCard.vue';
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import DramaEditCard from "@/components/Drama/DramaEditCard.vue"; // refs

export default {
  __name: 'DramaPage',

  setup(__props) {
    const dataArray = ref([]);
    const drama = ref(null);
    const pagerCount = ref(5);
    const size = ref(20);
    const total = ref(0);
    const page = ref(0);
    const cacheFilterInfo = ref({}); // computed

    const worldOutlook = computed(() => {
      return store.state.world_outlook ?? null;
    });
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : null);
    const natureOptions = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.drama_nature ?? null;
    }); // functions
    // const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);

    const getData = (filterInfo = null) => {
      if (!worldOutlook.value) return;
      let parameters = {
        'world_outlook_id': worldOutlook.value.id,
        'page': page.value,
        'size': size.value
      };

      if (filterInfo) {
        cacheFilterInfo.value = filterInfo;
        Object.entries(filterInfo).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } else if (Object.keys(cacheFilterInfo.value).length !== 0) {
        Object.entries(cacheFilterInfo.value).forEach(item => {
          parameters[item[0]] = item[1];
        });
      }

      request('drama/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        dataArray.value = response.data.dramas;
        total.value = response.data.numbers;
      });
      if (!natureOptions.value) store.dispatch('get_drama_nature');
    };

    const clickDrama = drama_id => {
      router.push(`/dramaDetail/${drama_id}`);
    };

    const updateFilter = (filterInfo = null) => {
      page.value = 0;
      getData(filterInfo);
    };

    const handlePageChange = index => {
      page.value = index - 1;
      getData();
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(DramaHeader, {
        onUpdateFilter: updateFilter
      }), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createVNode(_component_el_row, {
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_unref(inApostleType)(userType.value) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "create-drama-card",
          onClick: _cache[0] || (_cache[0] = $event => drama.value = {})
        }, [_createVNode(_unref(ElIcon), {
          size: "14"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }), _cache[3] || (_cache[3] = _createElementVNode("text", null, "创建世界观剧本", -1))])) : _createCommentVNode("", true)]),
        _: 1
      }), Object.keys(cacheFilterInfo.value).length !== 0 && dataArray.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [_createElementVNode("text", {
        class: "empty-data-tips"
      }, "未检测到符合条件的模组", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
        return _openBlock(), _createBlock(DramaListCard, {
          key: key,
          data: item,
          onClick: $event => clickDrama(item.id)
        }, null, 8, ["data", "onClick"]);
      }), 128))])), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true), drama.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 3,
        onClose: _cache[2] || (_cache[2] = $event => drama.value = null)
      }, {
        default: _withCtx(() => [_createVNode(DramaEditCard, {
          "drama-id": drama.value?.id,
          onReload: getData,
          onClose: _cache[1] || (_cache[1] = $event => drama.value = null)
        }, null, 8, ["drama-id"])]),
        _: 1
      })) : _createCommentVNode("", true)])], 4);
    };
  }

};